/* eslint-disable import/prefer-default-export */
// import config from ../const/config";
import config from '../const/config';
import { easyPost } from './utils';

export const getTiktokPlanInfo = easyPost(
  'common.sign.marketing.tiktok',
);

// 卡券创建订单
export const createMallOrder = easyPost('couponmall.order.create', {
  api: config.MARKET_API,
});

// 激活卡片
export const activeCard = easyPost('common.activate.property', {
  risk: true,
});

// 查询签约结果
export const getSignResult = easyPost('common.query.sign.result');

// 查询领卡后售卖商品
export const signedGoodsList = easyPost('mall.goods.list');

// 查询激活页动态哈口令
export const getDynamicHaCommand = easyPost('common.helloCommand.generate');

// 查询哈口令复制页面图片配置
export const getHaCommandPageInfo = easyPost('bff.component.data', { risk: true });

export const receiveActivityCoupon = easyPost('moon.scene.award', {
  api: config.MARKET_API,
  risk: true,
});
